<template>
  <div>
    <SignIn />
  </div>
</template>

<script>
import SignIn from '@/nfmp_components/SignIn.vue'
export default {
  components: {
    SignIn
  }
}
</script>